import React, { useEffect, useState } from "react";
import {
  Button,
  IconButton,
  Modal,
  Tooltip,
  InputLabel,
  CircularProgress,
  Typography,
  Card,
  Grid,
  CardContent,
  Select,
  MenuItem,
  TextField,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Alert,
  AlertTitle,
  Backdrop,
} from "@mui/material";
import { Theme, useTheme } from "@mui/material/styles";
import { createStyles, makeStyles } from "@mui/styles";
import { checkForRole } from "../../utils/GetAuth";
import { useLocalStorage } from "../../utils/LocalStorageHook";
import TableAbstraction from "../../componentUtils/TableAbstraction";
import LockIcon from "@mui/icons-material/Lock";
import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import SaveIcon from "@mui/icons-material/Save";
import Clear from "@mui/icons-material/Clear";
import {
  getRemotePriceEmailDL,
  saveRemotePriceEmailDL,
  deleteRemotePriceEmailDL,
} from "../../utils/RemotePriceManagement";

function getModalStyle() {
  const top = 50;
  const left = 50;

  return {
    top: `${top}%`,
    left: `${left}%`,
    transform: `translate(-${top}%, -${left}%)`,
    width: "800px",
    height: "300px",
  };
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    centerDiv: {
      textAlign: "center",
    },
    root: {},
    divWidth: {
      width: "100%",
    },
    gridSpaceable: {
      padding: theme.spacing(2),
    },
    gridMarginTop: {
      marginTop: theme.spacing(2),
    },
    modal: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
    modalGrid: {
      marginTop: theme.spacing(2),
    },
    modalTitle: {
      color: theme.palette.primary.main,
    },
    modalCard: {},
    modalText: {},
    modalInput: {
      width: "350px",
    },
    paper: {
      position: "absolute",
      backgroundColor: theme.palette.background.paper,
      border: `1px solid`,
      borderColor: theme.palette.border.main,
      boxShadow: theme.shadows[4],
      padding: theme.spacing(2, 2, 2),
    },
  })
);
export default function PriceChangeEmailDL() {
  const classes = useStyles();
  const [remotePriceEmailDLData, setRemotePriceEmailDLData] = useState<any[]>([]);
  const [salesOrg] = useLocalStorage("SETTINGS.salesOrg", "");
  const [doneLoading, setDoneLoading] = React.useState<boolean>();
  const [clientId] = useLocalStorage("SETTINGS.clientId", "100");
  const enabled = checkForRole(clientId, salesOrg, "vp_admin");
  const [muiTable, setMuiTable] = React.useState<any>({ rpp: 25 });
  const [confirmDelete, setConfirmDelete] = React.useState<boolean>(false);

  const [editedRow, setEditedRow] = React.useState<any | undefined>(undefined);
  const [editedRowDeliveringPlant, setEditedRowDeliveringPlant] = React.useState<string>("");
  const [editedRowParamName, setEditedRowParamName] = React.useState<string>("");
  const [editedEmailAddressValue, setEditedEmailAddressValue] = React.useState<string>("");
  const [previousEmailAddressValue, setPreviousEmailAddressValue] = React.useState<string>("");
  const [editedRowParamDefault, setEditedRowParamDefault] = React.useState<string>("");
  const [disabledSaveButton, setDisabledSaveButton] = React.useState<boolean>(false);

  const [modalStyle] = React.useState(getModalStyle);
  const [openEditWindow, setOpenEditWindow] = React.useState(false);
  const [backdropLoader, setBackdropLoader] = React.useState<boolean>(false);
  const [isEditOperation, setIsEditOperation] = React.useState<boolean>(false);

  const [error, setError] = useState(false);
  const [helperText, setHelperText] = useState("");

  const getRemotePriceEmailDLData: any = () => {
    getRemotePriceEmailDL(salesOrg)
      .then((responseEmailDL: any) => {
        setRemotePriceEmailDLData(responseEmailDL);
      })
      .catch((error: any) => {
        setRemotePriceEmailDLData([]);
      });
  };

  const handleDelete = () => {
    setBackdropLoader(true);
    const deletePayload: any = { emailAddress: editedEmailAddressValue };
    deleteRemotePriceEmailDL(salesOrg, deletePayload)
      .then((response) => {
        if (response && response.data) {
          setTimeout(() => {
            getRemotePriceEmailDLData();
            setBackdropLoader(false);
          }, 1000);
        }
      })
      .catch((error: any) => {
        setBackdropLoader(false);
      });
  };

  const handleEdit = (tableRow: any) => {
    setPreviousEmailAddressValue(tableRow?.email);
    setEditedEmailAddressValue(tableRow?.email);
    setOpenEditWindow(true);
  };

  const handleModalClose = () => {
    setOpenEditWindow(false);
    setEditedEmailAddressValue("");
    setPreviousEmailAddressValue("");
    setIsEditOperation(false);
  };

  const validateEmail = (email: string) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const handleModalSave = () => {
    setBackdropLoader(true);
    const saveEditPayload: any = {
      previuosEmailAddress: previousEmailAddressValue,
      emailAddress: editedEmailAddressValue,
      operationType: isEditOperation ? "edit" : "save",
    };
    saveRemotePriceEmailDL(salesOrg, saveEditPayload)
      .then((result: any) => {
        if (result && result.data) {
          setTimeout(() => {
            getRemotePriceEmailDLData();
            setBackdropLoader(false);
            handleModalClose();
          }, 1000);
        }
      })
      .catch((error: any) => {
        setBackdropLoader(false);
        handleModalClose();
      });
  };

  useEffect(() => {
    if (doneLoading) return;
    //Implement API calling to get list of price change request
    getRemotePriceEmailDLData();
    setDoneLoading(true);
  }, [doneLoading, remotePriceEmailDLData, salesOrg]);

  useEffect(() => {
    if (editedEmailAddressValue && editedEmailAddressValue !== "") {
      setDisabledSaveButton(false);
    } else {
      setDisabledSaveButton(true);
    }
  }, [editedEmailAddressValue]);

  return (
    <>
      <div className={classes.root}>
        {doneLoading && enabled ? (
          <TableAbstraction
            settingsKey="ADM_OPT"
            options={{
              draggableColumns: {
                enabled: true,
              },
              rowsPerPageOptions: [25, 50, 100],
              serverSide: false,
              selectableRows: "none",
              rowsPerPage: muiTable.rpp,
              onChangeRowsPerPage: (numberOfRows) => {
                muiTable.rpp = numberOfRows;
                setMuiTable(muiTable);
              },
              customToolbar: () => {
                return (
                  <Tooltip title={`Add Email`}>
                    <IconButton
                      onClick={() => {
                        handleModalClose();
                        setOpenEditWindow(true);
                      }}
                    >
                      <AddIcon />
                    </IconButton>
                  </Tooltip>
                );
              },
            }}
            title="Remote Price Email DL"
            columns={[
              {
                label: "Email Address",
                name: "email",
                options: {
                  filter: true,
                },
              },
              {
                label: "Edit",
                name: "action",
                options: {
                  filter: false,
                  renderCell: (params) => {
                    return (
                      <React.Fragment>
                        <Tooltip title={"Edit"}>
                          <IconButton>
                            <EditIcon
                              fontSize="small"
                              onClick={() => {
                                setIsEditOperation(true);
                                handleEdit(params.row);
                              }}
                            />
                          </IconButton>
                        </Tooltip>
                        <Tooltip title={"Delete"}>
                          <IconButton>
                            <DeleteIcon
                              fontSize="small"
                              onClick={() => {
                                setEditedEmailAddressValue(params?.row?.email);
                                setConfirmDelete(true);
                              }}
                            />
                          </IconButton>
                        </Tooltip>
                      </React.Fragment>
                    );
                  },
                },
              },
            ]}
            data={remotePriceEmailDLData}
          />
        ) : enabled ? (
          <div className={classes.centerDiv}>
            <CircularProgress color="primary" />
          </div>
        ) : (
          <Alert severity="error">
            <AlertTitle>
              <LockIcon /> Access Error
            </AlertTitle>
            You do not currently have access to <strong>Admin</strong> activities for the <strong>{salesOrg}</strong>{" "}
            bottler.
          </Alert>
        )}
        <Modal open={openEditWindow} onClose={handleModalClose}>
          <div style={modalStyle} className={classes.paper}>
            <Typography variant="h4" className={classes.modalTitle} paragraph>
              Approver Email Subscription
            </Typography>
            <Grid container spacing={2} className={classes.modalGrid}>
              <Grid item xs={12}>
                <Typography variant="subtitle1" className={classes.modalText} paragraph>
                  Remote Price Email DL
                </Typography>
                <Card className={classes.modalCard}>
                  <CardContent>
                    <Grid container spacing={1} className={classes.modalGrid}>
                      <Grid item xs={"auto"} md={"auto"} xl={"auto"}>
                        <InputLabel>Email Address</InputLabel>
                        <TextField
                          placeholder="Email Address"
                          type="text"
                          className={classes.modalInput}
                          value={editedEmailAddressValue}
                          onChange={(e) => {
                            const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
                            if (!emailRegex.test(e.target.value)) {
                              setError(true);
                              setHelperText("Please enter a valid email address.");
                            }else{
                              setError(false);
                              setHelperText("");
                            }
                            setEditedEmailAddressValue(
                              e.target.value && typeof e.target.value == "string" ? e.target.value : ""
                            );
                          }}
                          error={error} // Turns border red if true
                          helperText={helperText} // Displays message below the field
                        ></TextField>
                      </Grid>
                    </Grid>
                  </CardContent>
                </Card>
                <div style={{ paddingRight: "5px", marginTop: "15px", textAlign: "right" }}>
                  <React.Fragment>
                    <Tooltip title={"Save"}>
                      <IconButton disabled={disabledSaveButton} color="primary" onClick={handleModalSave}>
                        <SaveIcon />
                      </IconButton>
                    </Tooltip>
                    <Tooltip title={"Cancel"}>
                      <IconButton color="primary" onClick={handleModalClose}>
                        <Clear />
                      </IconButton>
                    </Tooltip>
                  </React.Fragment>
                </div>
              </Grid>
            </Grid>
          </div>
        </Modal>

        <Dialog open={confirmDelete} onClose={() => setConfirmDelete(false)}>
          <DialogTitle>Confirm Deletion</DialogTitle>
          <DialogContent>
            <DialogContentText>Are you sure you want to delete {editedEmailAddressValue}?</DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={() => {
                handleDelete();
                setConfirmDelete(false);
              }}
              color="primary"
            >
              Yes
            </Button>
            <Button
              onClick={() => {
                setEditedEmailAddressValue("");
                setConfirmDelete(false);
              }}
              color="primary"
              autoFocus
            >
              No
            </Button>
          </DialogActions>
        </Dialog>
      </div>
      <Backdrop
        sx={{
          color: "#fff",
          zIndex: (theme) => Math.max.apply(Math, Object.values(theme.zIndex)) + 1,
        }}
        open={backdropLoader}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </>
  );
}
